<template>
  <div>
    <v-row>
      <v-col>
        <v-sheet
          elevation="1"
          class="pa-4"
        >
          <div class="text-h2 font-weight-thin">
            Singulis
          </div>
          <div
            v-if="currentDate > singulisDepotEnd"
            class="lighten-5 red--text text--darken-4"
          >
            Le dépôt est terminé.
          </div>
          <p
            class="text-center my-12"
            v-html="singulisTravauxDescription"
          />
          <div v-if="singulis.length">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      Classe
                    </th>
                    <th class="text-left">
                      Elève
                    </th>
                    <th class="text-center">
                      Note
                    </th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="item in singulis"
                    :key="item.name"
                    :class="{'red lighten-5 red--text text--darken-4': !item.singulisWork.hasWork}"
                  >
                    <td>{{ item.name }}</td>
                    <td>
                      <span v-if="item.singulisWork.hasWork">
                        {{ item.singulisWork.studentName }}
                      </span>
                      <span v-else>
                        Copie manquante
                      </span>
                    </td>
                    <td class="text-center">
                      {{ item.singulisWork.studentScore }}
                    </td>
                    <th class="text-right">
                      <v-btn
                        v-if="item.singulisWork.hasWork"
                        icon
                        small
                        @click="viewSingulisWork(item)"
                      >
                        <v-icon>mdi-eye</v-icon>
                      </v-btn>
                      <v-btn
                        v-if="forceUpload || currentDate < singulisDepotEnd"
                        icon
                        small
                        @click="uploadSingulis(item)"
                      >
                        <v-icon>mdi-cloud-upload</v-icon>
                      </v-btn>
                    </th>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
          <div
            v-else
            class="text-center font-italic grey--text"
          >
            Pas de classe inscrite.
          </div>
          <br>
        </v-sheet>
      </v-col>

      <v-col>
        <v-sheet
          elevation="1"
          class="pa-4"
        >
          <div class="text-h2 font-weight-thin">
            Omnibus
          </div>
          <div
            v-if="currentDate > omnibusDepotEnd"
            class="lighten-5 red--text text--darken-4"
          >
            Le dépôt est terminé.
          </div>
          <p
            class="text-center my-12"
            v-html="omnibusTravauxDescription"
          />
          <div v-if="omnibus.length">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      Classe
                    </th>
                    <th class="text-left">
                      Titre
                    </th>
                    <th class="text-center">
                      Format
                    </th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="item in omnibus"
                    :key="item.name"
                    :class="{'red lighten-5 red--text text--darken-4': !item.omnibusWork.hasWork}"
                  >
                    <td>{{ item.name }}</td>
                    <td>
                      <span v-if="item.omnibusWork.hasWork">
                        {{ item.omnibusWork.title }}
                      </span>
                      <span v-else>
                        Copie manquante
                      </span>
                    </td>
                    <td class="text-center">
                      {{ item.omnibusWork.mimetype }}
                    </td>
                    <th class="text-right">
                      <v-btn
                        v-if="item.omnibusWork.hasWork"
                        icon
                        small
                        @click="viewOmnibusWork(item)"
                      >
                        <v-icon>mdi-eye</v-icon>
                      </v-btn>
                      <v-btn
                        v-if="forceUpload || currentDate < omnibusDepotEnd"
                        icon
                        small
                        @click="uploadOmnibus(item)"
                      >
                        <v-icon>mdi-cloud-upload</v-icon>
                      </v-btn>
                    </th>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
          <div
            v-else
            class="text-center font-italic grey--text"
          >
            Pas de classe inscrite.
          </div>
          <br>
        </v-sheet>
      </v-col>
    </v-row>
    <singulis-mes-travaux-dialog
      v-model="singulisMesTravauxShowIt"
      :data="singulisMesTravauxData"
    />
    <omnibus-mes-travaux-dialog
      v-model="omnibusMesTravauxShowIt"
      :data="omnibusMesTravauxData"
    />
  </div>
</template>

<script>
  import { get } from 'vuex-pathify'

  import SingulisMesTravauxDialog from './mestravaux/SingulisMesTravauxDialog.vue'
  import OmnibusMesTravauxDialog from './mestravaux/OmnibusMesTravauxDialog.vue'

  export default {
    components: {
      SingulisMesTravauxDialog,
      OmnibusMesTravauxDialog,
    },

    data: () => ({
      forceUpload: false,
      currentDate: new Date(),
      singulisMesTravauxShowIt: false,
      singulisMesTravauxData: null,
      omnibusMesTravauxShowIt: false,
      omnibusMesTravauxData: null,
    }),

    computed: {
      classes: get('artifex/classes'),
      singulisTravauxDescription: get('artifex/config.edition.singulisTravauxDescription'),
      omnibusTravauxDescription: get('artifex/config.edition.omnibusTravauxDescription'),
      singulisDepotEnd: get('artifex/config.edition.singulisDepotEnd'),
      omnibusDepotEnd: get('artifex/config.edition.omnibusDepotEnd'),
      omnibus () {
        return this.classes.filter(item => item.doOmnibus)
      },
      singulis () {
        return this.classes.filter(item => item.doSingulis)
      },
    },

    mounted () {
      if (location.search.indexOf('token=850f292e-f760-4472-9576-441030c8aa0f') >= 0) {
        this.forceUpload = true
      }
    },

    methods: {
      uploadSingulis (item) {
        this.singulisMesTravauxShowIt = true
        this.singulisMesTravauxData = item
      },
      uploadOmnibus (item) {
        this.omnibusMesTravauxShowIt = true
        this.omnibusMesTravauxData = item
      },
      viewSingulisWork (item) {
        const token = localStorage.getItem('jwt')
        const url = this.$http.getApiUrl(`/participant/classes/work/${item.singulisWork.storagePath}?token=${token}`)
        window.open(url, '_blank')
      },
      viewOmnibusWork (item) {
        const token = localStorage.getItem('jwt')
        const url = this.$http.getApiUrl(`/participant/classes/work/${item.omnibusWork.storagePath}?token=${token}`)
        window.open(url, '_blank')
      },
    },
  }
</script>
